import React from 'react';

import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';
import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarBodies,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  getBodyOptions,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';

function BodyFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedBodies =
    useTypedSelector(getSelectedFilters).selectedParams.selectedBodies;

  const bodyOptions = getBodyOptions(stockFilterParams);

  const handleChangeBody = (body: OptionType) => {
    dispatch(setCarBodies(handleChangeMultiSelect(body, selectedBodies)));
    dispatch(setPage(1));
  };

  const handleClearBody = () => {
    dispatch(setCarBodies([]));
    dispatch(setPage(1));
  };

  return (
    <StockFilterMultiSelect
      label="Тип кузова"
      options={bodyOptions}
      selectedOptions={selectedBodies}
      onChange={handleChangeBody}
      onClear={handleClearBody}
    />
  );
}

export default BodyFilter;
